export const enum KEYS {
  C = 'C',
  X = 'X',
  Z = 'Z',
  Y = 'Y',
  A = 'A',
  G = 'G',
  L = 'L',
  F = 'F',
  D = 'D',
  B = 'B',
  P = 'P',
  N = 'N',
  MINUS = '-',
  EQUAL = '=',
  DIGIT_0 = '0',
  DELETE = 'DELETE',
  UP = 'ARROWUP',
  DOWN = 'ARROWDOWN',
  LEFT = 'ARROWLEFT',
  RIGHT = 'ARROWRIGHT',
  ENTER = 'ENTER',
  SPACE = ' ',
  TAB = 'TAB',
  BACKSPACE = 'BACKSPACE',
  ESC = 'ESCAPE',
  PAGEUP = 'PAGEUP',
  PAGEDOWN = 'PAGEDOWN',
  F5 = 'F5',
}

export const HOTKEY_DOC = [
  {
    type: 'General',
    children: [
      { label: 'Cut', value: 'Ctrl + X' },
      { label: 'Copy', value: 'Ctrl + C' },
      { label: 'Paste', value: 'Ctrl + V' },
      { label: 'Quick Copy/Paste', value: 'Ctrl + D' },
      { label: 'Select All', value: 'Ctrl + A' },
      { label: 'Undo', value: 'Ctrl + Z' },
      { label: 'Restore', value: 'Ctrl + Y' },
      { label: 'Delete', value: 'Delete / Backspace' },
      { label: 'Print', value: 'Ctrl + P' },
      { label: 'Close popup', value: 'ESC' },
    ],
  },
  {
    type: 'Workspace Editor',
    children: [
      { label: 'Move canvas', value: 'Space + mouse drag' },
      { label: 'Zoom Canvas', value: 'Ctrl + Mouse Wheel' },
      { label: 'Zoom Canvas', value: 'Ctrl + =' },
      { label: 'Zoom Canvas', value: 'Ctrl + -' },
      { label: 'Fit Canvas to Screen', value: 'Ctrl + 0' },
    ],
  },
  {
    type: 'Element Operation',
    children: [
      { label: 'Move', value: '↑ / ← / ↓ / →' },
      { label: 'Lock', value: 'Ctrl + L' },
      { label: 'Combination', value: 'Ctrl + G' },
      { label: 'Ungroup', value: 'Ctrl + Shift + G' },
      { label: 'On Top', value: 'Alt + F' },
      { label: 'Background', value: 'Alt + B' },
      { label: 'Lock Aspect Ratio', value: 'Press Ctrl or Shift' },
      { label: 'Create horizontal/vertical lines', value: 'Hold Ctrl or Shift' },
      { label: 'Switch Focus Element', value: 'Tab' },
      { label: 'Confirm Image Cropping', value: 'Enter' },
    ],
  },
  {
    type: 'Table Edit',
    children: [
      { label: 'Focus to the next cell', value: 'Tab' },
      { label: 'Insert a row above', value: 'Ctrl + ↑' },
      { label: 'Insert a row below', value: 'Ctrl + ↓' },
      { label: 'Insert a column on the left', value: 'Ctrl + ←' },
      { label: 'Insert a column on the right', value: 'Ctrl + →' },
    ],
  },
  {
    type: 'Text Editor',
    children: [
      { label: 'Bold', value: 'Ctrl + B' },
      { label: 'Italic', value: 'Ctrl + I' },
      { label: 'Underline', value: 'Ctrl + U' },
      { label: 'Strikethrough', value: 'Ctrl + D' },
    ],
  },
]
